<div class="labels__container" [class.mobile-display]="isMobile$ | async">
  <app-product-label
    class="label"
    labelType="isNew"
    *ngIf="isNew"
  ></app-product-label>
  <app-product-label
    class="label"
    labelType="isTopProducts"
    *ngIf="isTopProducts"
  ></app-product-label>
  <app-product-label
    class="label"
    labelType="isPromotion"
    *ngIf="isPromotion"
  ></app-product-label>
  <div
          *ngIf="withoutStock"
          class="label label--without-stock"
  >
    {{'product-label.without-stock' | translate}}
  </div>
</div>
